import * as React from 'react';

import { PageProps, graphql } from 'gatsby';
import { IGatsbyImageData, getImage } from 'gatsby-plugin-image';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import classHand from 'stile-shared/assets/images/case-studies/class-hand.jpg';
import dylan from 'stile-shared/assets/images/case-studies/dylan.jpg';
import jovana from 'stile-shared/assets/images/case-studies/jovana.jpg';
import karma from 'stile-shared/assets/images/case-studies/karma.jpg';
import lab from 'stile-shared/assets/images/case-studies/lab.jpg';
import stileX from 'stile-shared/assets/images/case-studies/stile-x.jpg';
import teacherWithFlag from 'stile-shared/assets/images/case-studies/teacher-with-flag.jpg';
import testimonialBackground from 'stile-shared/assets/images/homepage/homepage_testimonial_background.svg';
import testimonialBackgroundMobile from 'stile-shared/assets/images/homepage/homepage_testimonial_background_mobile.svg';
import featureCaseStudy from 'stile-shared/assets/videos/feature_case_study.mp4';

import { Button } from 'stile-shared/src/components/2024/common/Button';
import CaseStudiesComponent from 'stile-shared/src/components/2024/common/CaseStudies/CaseStudyList';
import { ExploreCurriculum } from 'stile-shared/src/components/2024/common/ExploreCurriculum';
import Hearts from 'stile-shared/src/components/2024/common/Hearts';
import TitleMenu from 'stile-shared/src/components/2024/common/Included/WITBTitleMenu/WITBTitleMenu';
import Top from 'stile-shared/src/components/2024/common/Included/WITBTopSection/WITBTopSection';
import { Link } from 'stile-shared/src/components/2024/common/Link';
import { VideoPlayer } from 'stile-shared/src/components/2024/common/VideoPlayer';
import ReviewsSlider from 'stile-shared/src/components/2024/layout/ReviewsSlider/ReviewsSlider';
import { Section } from 'stile-shared/src/components/2024/layout/Section';
import VideoGallery from 'stile-shared/src/components/2024/layout/VideoGallery';
import { CaseStudyWithImageData } from 'stile-shared/src/utils/case-studies';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { allCaseStudies } from '../../../data/caseStudies';

const ContentWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  color: var(--white);
  .bodyHeader {
    margin: 0 0 40px;
    color: var(--stile-grey-8);
    text-align: center;
  }
  .teachers {
    padding-bottom: 134px;
  }
  @media (max-width: 768px) {
    padding-bottom: 0px;
    padding-top: 40px;
    .teachers {
      padding-bottom: 60px;
    }
  }
`;

const Container = styled.div`
  max-width: 1160px;
  padding: 0 0 90px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .--small {
    color: var(--Primary-Stile-Grey-5, #928d88);
    padding-bottom: 30px;
  }
  @media (max-width: 1220px) {
    margin: 0 60px;
    max-width: none;
  }
  @media (max-width: 768px) {
    margin: 0;
    padding: 0 25px 29px;
    .--small {
      padding-bottom: 0px;
    }
  }
`;

const CaseStudiesPageLayout = styled(PageLayout)``;
const TitleMenuContainer = styled.div`
  display: flex !important;
  flex-direction: column !important;
  padding-bottom: 80px !important;
  p {
    max-width: 563px;
  }
  h1 {
    max-width: 563px;
    align-self: center;
    @media (max-width: 768px) {
      max-width: 300px;
    }
  }
  .content {
    padding-top: 0px !important;
    @media (max-width: 768px) {
      .grid-layout {
        margin-top: 28px !important;
      }
      padding-top: 0px !important;
    }
  }
  .video {
    overflow: visible !important;
    .skeleton.skeleton-video,
    video {
      border-radius: 32px;
    }
    aspect-ratio: 1160/653;
    border-radius: 32px;
    box-shadow: 0px 43px 26px 0px rgba(0, 0, 0, 0.04), 0px 19px 19px 0px rgba(0, 0, 0, 0.06),
      0px 5px 11px 0px rgba(0, 0, 0, 0.07);
    margin: 80px auto 70px;
    @media (max-width: 768px) {
      .skeleton.skeleton-video,
      video {
        border-radius: 16px;
      }
      padding-top: 0px !important;
      border-radius: 16px !important;
      box-shadow: 0px 12.603px 7.621px 0px rgba(0, 0, 0, 0.04),
        0px 5.569px 5.569px 0px rgba(0, 0, 0, 0.06), 0px 1.466px 3.224px 0px rgba(0, 0, 0, 0.07);
      margin: 40px auto 32px;
    }
  }
  @media (max-width: 768px) {
    padding: 0 25px 20px !important;
    margin: 0 !important;
    > div > div {
      padding-top: 17px !important;
    }
  }
`;

const ReviewsComponent = styled.div`
  background-color: var(--stile-green-3);
  background-image: url(${testimonialBackground});
  background-size: fill;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    background-image: url(${testimonialBackgroundMobile});
  }
  .splide {
    &:nth-child(2) {
      .splide__track {
        padding-bottom: 72px;
        @media (max-width: 768px) {
          padding-bottom: 60px;
        }
      }
    }
  }
  .hearts-container {
    position: relative;
    padding: 0px;
    margintop: 0px;
    height: 0;
    overflow: visible;
    width: 100%;
    max-width: 1160px;
    @media (max-width: 1220px) {
      padding: 0 60px;
    }
    @media (max-width: 768px) {
      padding: 0 25px;
    }
    &:last-child {
      div {
        &:last-child {
          right: 25px;
          top: -30px;
        }
      }
    }
  }
  .hearts {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    h4 {
      color: white;
      margin: 60px 20px 40px;
    }

    .quote {
      font-size: 14px !important;
      font-weight: 600 !important;
      line-height: 21px !important;
      @media (max-width: 768px) {
        line-height: 18px !important;
      }
    }
    .reviewer {
      font-weight: 400 !important;
    }
  }
`;

const FeatureSection = styled(Section)`
  margin-bottom: 20px !important;
  .content {
    padding-top: 0 !important;
  }
  @media (max-width: 900px) {
    background: rgba(0, 203, 80, 0.1) !important;
    padding: 0 0 40px !important;
    margin-bottom: 0 !important;
    .content {
      margin: 0 !important;
    }
    .grid-layout {
      margin-top: 0 !important;
    }
  }
  h2 {
    margin-bottom: 80px !important;
    @media (max-width: 900px) {
      margin-bottom: 40px !important;
    }
  }
  .main {
    grid-column: 1 / span 12;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 0 26px;
    border-radius: 16px;
    background: rgba(0, 203, 80, 0.1);
    @media (max-width: 900px) {
      background: none;
    }
  }
  .left {
    grid-column: 1 / span 7;
    max-height: 375px;
    @media (max-width: 1220px) and (min-width: 901px) {
      max-height: none;
      height: auto;
    }
    @media (max-width: 900px) {
      grid-column: 1 / span 12;
      max-height: none;
      padding-bottom: 20px;
    }
  }
  .right {
    grid-column: 8 / span 5;
    padding: 32px 32px 32px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (max-width: 900px) {
      grid-column: 1 / span 12;
      padding: 0 25px;
    }
    h4 {
      margin-bottom: 20px;
      @media (max-width: 900px) {
        margin-bottom: 12px;
      }
    }
    p {
      margin-right: 44px;
      @media (max-width: 900px) {
        margin: 0 0 20px;
      }
    }
    .h7 {
      color: var(--stile-green-3);
      margin-bottom: 4px;
    }
  }
`;

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 16px 0 0 16px;
  .video {
    div {
      display: flex !important;
      justify-content: center !important;
    }
    @media (max-width: 1220px) and (min-width: 901px) {
      video {
        width: unset !important;
        max-height: 437px !important;
      }
    }
  }
  @media (max-width: 900px) {
    border-radius: 0;
  }
`;

export function Head() {
  return (
    <SEO
      slug="/why-choose-stile/case-studies"
      description="Teachers are using Stile to boost engagement, deepen understanding, and achieve better outcomes."
      title="Case Studies | Stile"
      opengraphTitle="Case Studies | Stile"
      opengraphDescription="Teachers are using Stile to boost engagement, deepen understanding, and achieve better outcomes."
    />
  );
}

type DataProps = {
  allCaseStudyImages: {
    nodes: Array<{
      base: string;
      childImageSharp: {
        gatsbyImageData: IGatsbyImageData;
      };
    }>;
  };
  file: {
    childImageSharp: { gatsbyImageData: IGatsbyImageData };
  };
};

function CaseStudiesPage({ data, ...props }: PageProps<DataProps>) {
  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  // --- 1) build a map from filename → imageData
  const imageMap = data.allCaseStudyImages.nodes.reduce<Record<string, IGatsbyImageData>>(
    (acc, { base, childImageSharp: { gatsbyImageData } }) => {
      acc[base] = gatsbyImageData;
      return acc;
    },
    {}
  );

  // --- 2) enrich case studies with the image data from the map
  const enrichedCaseStudies: CaseStudyWithImageData[] = allCaseStudies.map((cs) => {
    const filename = cs.image.split('/').pop(); // get the filename, e.g., 'teacher2.png'
    if (!filename) {
      throw new Error(`Invalid image path: ${cs.image}`);
    }
    const imgData = imageMap[filename];
    if (!imgData) {
      throw new Error(`Case study image missing from GraphQL: ${filename}`);
    }
    return {
      ...cs,
      imageData: imgData,
    };
  });

  // --- featured: pull out the first one
  const featureIndex = 0;
  const featured = enrichedCaseStudies[featureIndex];

  const image = getImage(data.file.childImageSharp.gatsbyImageData);
  if (!image) {
    throw new Error('Failed to retrieve image data for image.jpg');
  }

  const exploreCards = [
    {
      title: 'Why HQIM?',
      description: 'Why High-Quality Instructional Materials make all the difference.',
      url: '/why-choose-stile/high-quality-instructional-materials/',
    },
    {
      title: 'Reading, Writing & Mathematics',
      description: 'Transforms every lesson into a multidisciplinary powerhouse.',
      url: '/why-choose-stile/boost-reading-writing-and-math/',
    },
    {
      title: 'What’s Included',
      description:
        'A complete, comprehensive curriculum — used, loved, and perfected by thousands of teachers.',
      url: '/what-is-stile/whats-included/',
    },
  ];
  const reviews = [
    {
      name: 'Elizabeth',
      school: 'Lake Oswego',
      quote:
        "My favorite thing about Stile is that every feature in it is 100% customizable and editable by the teacher, so I can take the great platform that's already there and make it work for my students.",
    },
    {
      name: 'Zach',
      school: 'Briggs Middle School',
      quote:
        "What I like about Stile is that it isn't students just staring at a screen, it is driving a conversation... This is by far the most excited I have been about curriculum.",
    },
    {
      name: 'Tavin',
      school: 'Armand Larive Middle School',
      quote:
        "I think that out of all the curricula I've used, this one is very tech-savvy, and I believe students will be more engaged.",
    },
    {
      name: 'McKenzie',
      school: 'Siuslaw Middle School',
      quote:
        "I don't have to make it engaging because it's already engaging. It's just so editable, but it doesn't have to be. It's the perfect happy medium.",
    },
    {
      name: 'Lex',
      school: 'Cheldelin Middle school',
      quote: "Stile has the best customer service I've ever had in any part of my life.",
    },
    {
      name: 'Jill',
      school: 'Peak Charter Academy',
      quote: 'I wish I had this when I was a first year teacher.',
    },
    {
      name: 'Delfino',
      school: 'Hermiston School District',
      quote:
        'I think the biggest complement that I saw in Stile was how easy it was to customize our lessons and make them specific to our region. The kids will be like, was this written for us?',
    },
    {
      name: 'Chelsea',
      school: 'North Marion Middle School',
      quote:
        "The combination of the quality of the curriculum and the support that you get from the team is unlike any other curriculum that I've worked with.",
    },
    {
      name: 'Bettina',
      school: 'German International School',
      quote: "It engages kids in a way that a normal book wouldn't, or that I can't on my own.",
    },
    {
      name: 'Brittany',
      school: 'Mooresville Graded School District',
      quote: 'I got the highest scores in the district! Thank you Stile!!',
    },
  ];

  const exploreCurriculumImage = (
    <StaticImage
      src="../../components/our-principles/images/teachersaying_quality_4.png"
      alt="Stacked documents with celestial diagram showing sun and orbiting planets"
      placeholder="blurred"
      layout="constrained"
      width={124}
      height={124}
    />
  );

  return (
    <CaseStudiesPageLayout {...props}>
      <TitleMenuContainer className="content">
        <TitleMenu>
          <Top
            title="Real classrooms, real impact"
            description="Teachers are using Stile to boost engagement, deepen understanding, and achieve better outcomes."
          />
        </TitleMenu>
      </TitleMenuContainer>
      <ContentWrapper>
        <VideoGallery
          className="teachers"
          videoAspectRatio="1"
          items={[
            { type: 'img', url: jovana },
            { type: 'img', url: stileX },
            { type: 'img', url: lab },
            { type: 'img', url: dylan },
            { type: 'img', url: classHand },
            { type: 'img', url: teacherWithFlag },
            { type: 'img', url: karma },
          ]}
        />
        <h2 className="bodyHeader">Hear from our teachers</h2>
      </ContentWrapper>
      <FeatureSection id={featured.slug}>
        <div className="main">
          <Link className="left" url={`/why-choose-stile/case-studies/${featured.slug}`}>
            <VideoWrapper>
              <VideoPlayer url={featureCaseStudy} borderRadius="0" />
            </VideoWrapper>
          </Link>
          <div className="right">
            <div>
              <h4>{featured.title}</h4>
              <h6 className="h7">{featured.school}</h6>
              <p>{featured.description}</p>
            </div>
            <Button
              style="primary"
              size="large"
              href={`/why-choose-stile/case-studies/${featured.slug}`}
              label="Read full case study"
            />
          </div>
        </div>
      </FeatureSection>
      <Container>
        <CaseStudiesComponent caseStudies={enrichedCaseStudies} featureIndex={featureIndex} />
      </Container>
      <ReviewsComponent>
        <div className="hearts" style={{ position: 'relative' }}>
          <h4> What educators are saying</h4>
        </div>
        <div className="hearts-container">
          <Hearts />
        </div>
        <ReviewsSlider reviews={reviews} header="What educators are saying" />
        {isMobile && (
          <div className="hearts-container">
            <Hearts />
          </div>
        )}
      </ReviewsComponent>
      <ExploreCurriculum
        title="Explore our core science curriculum"
        exploreCardsData={exploreCards}
        image={exploreCurriculumImage}
      />
    </CaseStudiesPageLayout>
  );
}

export const query = graphql`
  query CaseStudyImages {
    # 1) pull in every PNG in case-studies/
    allCaseStudyImages: allFile(filter: { relativePath: { glob: "case-studies/*.jpg" } }) {
      nodes {
        base
        childImageSharp {
          gatsbyImageData(width: 400, placeholder: BLURRED, quality: 80)
        }
      }
    }
    # 2) your featured banner image is still image.png
    file(relativePath: { eq: "case-studies/hands-on-science.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 600, quality: 90, placeholder: DOMINANT_COLOR)
      }
    }
  }
`;

export default CaseStudiesPage;
